import { jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { sizeVariants } from "./constants.js";
import { spreadSx } from "../../../utils/spreadSx.js";
import { getColor } from "./utils/getColor.js";
const InputTip = ({
  ignoreHeight,
  size = "md",
  sx,
  hide,
  color,
  children,
  disabled,
  className
}) => {
  const computedStyles = useMemo(() => [
    styles.body,
    sizeStyles.body[size],
    ignoreHeight ? sizeStyles.bodyCompensateHeight[size] : {},
    styles.color(color, disabled),
    ...spreadSx(sx)
  ], [color, disabled, ignoreHeight, size, sx]);
  return hide ? null : /* @__PURE__ */ jsx(Box, { sx: styles.tipContainer, className: "id-input-hint", children: /* @__PURE__ */ jsx(Box, { sx: computedStyles, className, children: typeof children == "string" ? /* @__PURE__ */ jsx(
    Typography,
    {
      variant: sizeVariants[size],
      sx: [{ display: "block" }, sizeStyles.text[size]],
      children
    }
  ) : children }) });
}, HINT_HEIGHT = {
  sm: 24,
  md: 24,
  lg: 30
}, sizeStyles = {
  text: {
    sm: {
      paddingBottom: 3
    },
    md: {
      paddingBottom: 3
    },
    lg: {
      paddingBottom: 3
    }
  },
  bodyCompensateHeight: {
    sm: {
      marginBottom: -HINT_HEIGHT.sm
    },
    md: {
      marginBottom: -HINT_HEIGHT.md
    },
    lg: {
      marginBottom: -HINT_HEIGHT.lg
    }
  },
  body: {
    sm: {
      minHeight: HINT_HEIGHT.sm - 2,
      marginTop: 2
    },
    md: {
      minHeight: HINT_HEIGHT.md - 3,
      marginTop: 3
    },
    lg: {
      minHeight: HINT_HEIGHT.lg - 3,
      marginTop: 3
    }
  }
}, styles = {
  tipContainer: { width: "100%" },
  body: {
    span: {
      minWidth: 10
    },
    textAlign: "start",
    width: "100%"
  },
  color: (color, disabled) => ({
    span: {
      color: (t) => getColor(t, color, disabled) ?? t.palette.grey[800]
    }
  })
};
export {
  InputTip
};
//# sourceMappingURL=InputTip.js.map
